module.exports = __webpack_public_path__ + "img/spirit_big_3.16a86514.png";